import { withZod } from '@remix-validated-form/with-zod';
import { z } from 'zod';

export const forgotPasswordSchema = z.object({
	email: z.string().email('Please enter a valid email').max(254, 'Max length of 254'),
});

export const forgotPasswordValidator = withZod(forgotPasswordSchema);

export type ForgotPasswordForm = z.infer<typeof forgotPasswordSchema>;
